import { Modal } from '@shared/ui/Modal'
import { Button } from '@shared/ui/Button'
import { ENV } from '@shared/config/env'
import styles from './CancelAutoRenewConfirmModal.module.css'

interface CancelAutoRenewConfirmModalProps {
  /** Дата окончания подписки в локальном формате — для подстановки в текст */
  expiresAtFormatted?: string | null
  isSubmitting?: boolean
  errorText?: string | null
  onConfirm: () => void
  onClose: () => void
}

/**
 * Модалка подтверждения отключения автопродления.
 * После подтверждения снаружи вызывается `setAutoRenew({enabled:false})`.
 */
export const CancelAutoRenewConfirmModal = ({
  expiresAtFormatted,
  isSubmitting = false,
  errorText,
  onConfirm,
  onClose,
}: CancelAutoRenewConfirmModalProps) => {
  const variant = ENV.IS_TG ? 'bottomSheet' : 'center'

  return (
    <Modal onClose={onClose} variant={variant} showClose>
      <div className={styles.content}>
        <h3 className={styles.title}>Отменить подписку?</h3>
        <p className={styles.text}>
          {expiresAtFormatted
            ? `Подписка останется активной до ${expiresAtFormatted}. После этого автопродление будет отключено.`
            : 'Подписка останется активной до конца текущего периода. После этого автопродление будет отключено.'}
        </p>

        {errorText && <p className={styles.error}>{errorText}</p>}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.confirmButton}
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Отменяем…' : 'Отменить подписку'}
          </button>
          <Button variant="secondary" onClick={onClose} disabled={isSubmitting} block>
            Оставить
          </Button>
        </div>
      </div>
    </Modal>
  )
}
